import { css } from "styled-components"

export const fontWeight = (weight: number): string => {
  return `
  font-weight: ${weight};
  font-variation-settings: "wght" ${weight};`
}

export const defaultTextInputStyles = css`
  position: relative;
  padding-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 1;
  width: 100%;
  min-width: 200px;
  &:focus-within {
    label {
      color: var(--blue);
    }
  }
  .PhoneInput {
    width: 100%;
  }
  input,
  textarea,
  option > span,
  [data-role="phone-number-formatting"] {
    font-size: 14px;
    line-height: 19px;
    height: 40px;
    padding: 0 6px;
    ${fontWeight(600)};
    color: var(--grey);
  }
  input,
  span,
  textarea,
  select,
  option {
    width: 100%;
    transition: all 100ms ease-out;
    flex-shrink: 1;
    font-size: var(--step--2);
    font-weight: 600;
    color: var(--queen-blue);
    padding: 6px 10px;
    border-bottom: 1px solid #c4c4c4;
    &:focus {
      border-bottom: 2px solid var(--blue);
    }
    &:disabled {
      border-color: grey;
    }
    &:not([type="tel"]) {
      padding: 6px 0;
    }
    ::placeholder {
      color: var(--graph-axis-label-color);
      opacity: 0.8;
      ${fontWeight(400)};
    }
    &[data-valid="false"] {
      border-bottom: 1px solid var(--red-text);
    }
  }
  select {
    cursor: pointer;
  }
  option,
  input {
    font-weight: 500;
  }
  label {
    font-size: var(--step--2);
    font-weight: 600;
    text-transform: capitalize;
    color: var(--queen-blue);
    width: fit-content;
    &[data-valid="false"] {
      color: var(--red-text);
    }
  }
  [data-role="validation"] {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* &[data-valid="false"] {
      border-bottom: none;
      border: 1px solid #ffc1c1;
      border-radius: 4px;
      box-shadow: 1px 1px 4px 0px #ffc1c1;
    } */
  }
`
